import { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader, SearchBar } from "../../../components";
import { Colors } from "../../../constants/styles";
import LogoPerusahaanSpFidusiaBlackAndWhite from "../../../assets/LogoPerusahaanSpFidusiaBlackAndWhite.jpg";
import { Container, Card, Form, Row, Col, InputGroup } from "react-bootstrap";
import {
  Box,
  ButtonGroup,
  Paper,
  Alert,
  Button,
  Snackbar,
  Autocomplete,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Typography,
  CardHeader,
  CardActionArea,
  CardMedia,
  CardActions,
  IconButton,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import Carousel from "react-elastic-carousel";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import { makeStyles } from "@mui/styles";
import { NumericFormat } from "react-number-format";
import { ReactSketchCanvas } from "react-sketch-canvas";
import { KeyOffRounded } from "@mui/icons-material";
import firebase from "firebase/compat/app";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { formatDate } from "../../../constants/helper";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const UbahSurveyFidusiaLangsung = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [alamatSama, setAlamatSama] = useState(false);
  const [registerFidusiaId, setRegisterFidusiaId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [cif, setCif] = useState("");
  const [nikCustomer, setNikCustomer] = useState("");
  const [noKkCustomer, setNoKkCustomer] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [namaPanggilanCustomer, setNamaPanggilanCustomer] = useState("");
  const [tempatLahirCustomer, setTempatLahirCustomer] = useState("");
  const [tanggalLahirCustomer, setTanggalLahirCustomer] = useState(new Date());
  const [jenisKelaminCustomer, setJenisKelaminCustomer] = useState("");
  const [agamaCustomer, setAgamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [alamatCustomer, setAlamatCustomer] = useState("");
  const [alamatTTCustomer, setAlamatTTCustomer] = useState("");
  const [kodeProvinsi, setKodeProvinsi] = useState("");
  const [ketProvinsi, setKetProvinsi] = useState("");
  const [kodeProvinsiTT, setKodeProvinsiTT] = useState("");
  const [ketProvinsiTT, setKetProvinsiTT] = useState("");
  const [kodeKabupaten, setKodeKabupaten] = useState("");
  const [ketKabupaten, setKetKabupaten] = useState("");
  const [kodeKabupatenTT, setKodeKabupatenTT] = useState("");
  const [ketKabupatenTT, setKetKabupatenTT] = useState("");
  const [kodeKecamatan, setKodeKecamatan] = useState("");
  const [ketKecamatan, setKetKecamatan] = useState("");
  const [kodeKecamatanTT, setKodeKecamatanTT] = useState("");
  const [ketKecamatanTT, setKetKecamatanTT] = useState("");
  const [kodeKelurahan, setKodeKelurahan] = useState("");
  const [ketKelurahan, setKetKelurahan] = useState("");
  const [kodeKelurahanTT, setKodeKelurahanTT] = useState("");
  const [ketKelurahanTT, setKetKelurahanTT] = useState("");
  const [kodePos, setKodePos] = useState("");
  const [kodePosTT, setKodePosTT] = useState("");
  const [statusPerkawinanCustomer, setStatusPerkawinanCustomer] = useState("");
  const [pekerjaanCustomer, setPekerjaanCustomer] = useState("");
  const [kewarganegaraanCustomer, setKewarganegaraanCustomer] = useState("");

  const [namaPerusahaanCustomer, setNamaPerusahaanCustomer] = useState("");
  const [bidangUsahaCustomer, setBidangUsahaCustomer] = useState("");
  const [jabatanCustomer, setJabatanCustomer] = useState("");
  const [alamatPerusahaanCustomer, setAlamatPerusahaanCustomer] = useState("");
  const [noTeleponPerusahaanCustomer, setNoTeleponPerusahaanCustomer] =
    useState("");
  const [lamaKerjaCustomer, setLamaKerjaCustomer] = useState("");
  const [gajiPekerjaanCustomer, setGajiPekerjaanCustomer] = useState("0");
  const [pendapatanLainCustomer, setPendapatanLainCustomer] = useState("0");

  // Data Penjamin
  const [nikPenjamin, setNikPenjamin] = useState("");
  const [noKkPenjamin, setNoKkPenjamin] = useState("");
  const [namaPenjamin, setNamaPenjamin] = useState("");
  const [tempatLahirPenjamin, setTempatLahirPenjamin] = useState("");
  const [tanggalLahirPenjamin, setTanggalLahirPenjamin] = useState(null);
  const [jenisKelaminPenjamin, setJenisKelaminPenjamin] = useState("");
  const [agamaPenjamin, setAgamaPenjamin] = useState("");
  const [noTeleponPenjamin, setNoTeleponPenjamin] = useState("");
  const [alamatPenjamin, setAlamatPenjamin] = useState("");
  const [kodeProvinsiPenjamin, setKodeProvinsiPenjamin] = useState("");
  const [ketProvinsiPenjamin, setKetProvinsiPenjamin] = useState("");
  const [kodeKabupatenPenjamin, setKodeKabupatenPenjamin] = useState("");
  const [ketKabupatenPenjamin, setKetKabupatenPenjamin] = useState("");
  const [kodeKecamatanPenjamin, setKodeKecamatanPenjamin] = useState("");
  const [ketKecamatanPenjamin, setKetKecamatanPenjamin] = useState("");
  const [kodeKelurahanPenjamin, setKodeKelurahanPenjamin] = useState("");
  const [ketKelurahanPenjamin, setKetKelurahanPenjamin] = useState("");
  const [kodePosPenjamin, setKodePosPenjamin] = useState("");
  const [statusPerkawinanPenjamin, setStatusPerkawinanPenjamin] = useState("");
  const [namaPerusahaanPenjamin, setNamaPerusahaanPenjamin] = useState("");
  const [alamatPerusahaanPenjamin, setAlamatPerusahaanPenjamin] = useState("");
  const [pekerjaanPenjamin, setPekerjaanPenjamin] = useState("");
  const [lamaKerjaPenjamin, setLamaKerjaPenjamin] = useState("");
  const [kewarganegaraanPenjamin, setKewarganegaraanPenjamin] = useState("");
  const [hubunganPenjamin, setHubunganPenjamin] = useState("");

  const [alamatSamaPenjamin, setAlamatSamaPenjamin] = useState(false);
  const [alamatTTPenjamin, setAlamatTTPenjamin] = useState("");
  const [kodeProvinsiTTPenjamin, setKodeProvinsiTTPenjamin] = useState("");
  const [ketProvinsiTTPenjamin, setKetProvinsiTTPenjamin] = useState("");
  const [kodeKabupatenTTPenjamin, setKodeKabupatenTTPenjamin] = useState("");
  const [ketKabupatenTTPenjamin, setKetKabupatenTTPenjamin] = useState("");
  const [kodeKecamatanTTPenjamin, setKodeKecamatanTTPenjamin] = useState("");
  const [ketKecamatanTTPenjamin, setKetKecamatanTTPenjamin] = useState("");
  const [kodeKelurahanTTPenjamin, setKodeKelurahanTTPenjamin] = useState("");
  const [ketKelurahanTTPenjamin, setKetKelurahanTTPenjamin] = useState("");
  const [kodePosTTPenjamin, setKodePosTTPenjamin] = useState("");

  const [uangMuka, setUangMuka] = useState("");
  const [pinjamanAju, setPinjamanAju] = useState("");
  const [angPerBulan, setAngPerBulan] = useState("");
  const [tenor, setTenor] = useState("");

  // DATA KENDARAAN
  const [merk, setMerk] = useState("");
  const [tipe, setTipe] = useState("");
  const [tahun, setTahun] = useState("");
  const [warna, setWarna] = useState("");
  const [isi, setIsi] = useState("");
  const [nopol, setNopol] = useState("");
  const [noRangka, setNoRangka] = useState("");
  const [noMesin, setNoMesin] = useState("");
  const [tglStnk, setTglStnk] = useState(null);
  const [noBpkb, setNoBpkb] = useState("");
  const [bpkbAN, setBpkbAN] = useState("");
  const [bpkbAlamat, setBpkbAlamat] = useState("");

  const [linkMapsSurvey, setLinkMapsSurvey] = useState("");

  // DATA REFERENSI
  const [namaRefRegister, setNamaRefRegister] = useState("");
  const [alamatRefRegister, setAlamatRefRegister] = useState("");
  const [teleponRefRegister, setTeleponRefRegister] = useState("");
  const [hubunganRefRegister, setHubunganRefRegister] = useState("");
  // const [statusPerkawinanRefRegister, setStatusPerkawinanRefRegister] =
  //   useState("");
  const [namaRef2Register, setNamaRef2Register] = useState("");
  const [alamatRef2Register, setAlamatRef2Register] = useState("");
  const [teleponRef2Register, setTeleponRef2Register] = useState("");
  const [hubunganRef2Register, setHubunganRef2Register] = useState("");
  // const [statusPerkawinanRef2Register, setStatusPerkawinanRef2Register] =
  //   useState("");
  const [namaRef3Register, setNamaRef3Register] = useState("");
  const [alamatRef3Register, setAlamatRef3Register] = useState("");
  const [teleponRef3Register, setTeleponRef3Register] = useState("");
  const [hubunganRef3Register, setHubunganRef3Register] = useState("");
  // const [statusPerkawinanRef3Register, setStatusPerkawinanRef3Register] =
  //   useState("");

  // DATA PINJAMAN
  const [hargaOtr, setHargaOtr] = useState("");
  const [tglJtTempo, setTglJtTempo] = useState(null);
  const [tujuanPenggunaanDana, setTujuanPenggunaanDana] = useState("");
  const [pendinganPengurusan, setPendinganPengurusan] = useState("");
  const [kodeMarketing, setKodeMarketing] = useState("");
  const [kodeSurveyor, setKodeSurveyor] = useState("");

  const [keteranganSurvey, setKeteranganSurvey] = useState(
    "Saya menyatakan benar dan akurat atas seluruh informasi dan atau dokumen yang saya berikan kepada PT Sistem Gadai. Apabila ternyata dikemudian hari informasi tersebut tidak benar, saya bersedia mempertanggungjawabkannya, dan sanggup menaati segala peraturan perjanjian yang telah ditetapkan oleh perusahaan. Tujuan setiap setoran dana bukanlah berasal dari Tindak Pidana Pencucian Uang dan tujuan Pinjaman dana bukan bertujuan untuk kaitanya Tindak Pidana Pencucian Uang, Tindak Pidana Pendanaan Terorisme maupun Pendanaan Proliferasi Senjata Pemusnah Masal. Apabila di kemudian hari terbukti melakukan tujuan tujuan tersebut maka saya bersedia tunduk pada peraturan perundang-undangan yang berlaku."
  );
  const [keterangan, setKeterangan] = useState("");

  const [denahLokasiSurvey, setDenahLokasiSurvey] = useState("");
  const [denahLokasiSurveyLama, setDenahLokasiSurveyLama] = useState("");
  const [ttdSurvey, setTtdSurvey] = useState("");
  const [ttdSurveyLama, setTtdSurveyLama] = useState("");
  const [namaTtdSurvey, setNamaTtdSurvey] = useState("");

  const canvasRef = useRef(null);
  const [eraseMode, setEraseMode] = useState(false);

  const canvasRefDenahLokasiSurvey = useRef(null);
  const [eraseModeDenahLokasiSurvey, setEraseModeDenahLokasiSurvey] =
    useState(false);

  const [statusSurvey, setStatusSurvey] = useState("");
  const [tglRejectSurvey, setTglRejectSurvey] = useState(new Date());
  const [alasanRejectSurvey, setAlasanRejectSurvey] = useState("");
  const [isReject, setIsReject] = useState(false);
  const [alasanPendingSurvey, setAlasanPendingSurvey] = useState("");
  const [isPending, setIsPending] = useState(false);

  const [statusSurveyManager, setStatusSurveyManager] = useState("");

  const [kelurahans, setKelurahans] = useState([]);
  const [kecamatans, setKecamatans] = useState([]);
  const [kabupatens, setKabupatens] = useState([]);
  const [provinsis, setProvinsis] = useState([]);
  const [marketings, setMarketings] = useState([]);
  const [surveyors, setSurveyors] = useState([]);
  const [registers, setRegisters] = useState([]);
  const [tipes, setTipes] = useState([]);
  const [warnas, setWarnas] = useState([]);
  const [previewPdfFormulir, setPreviewPdfFormulir] = useState(false);
  const [searchTermRegister, setSearchTermRegister] = useState("");
  const [openRegister, setOpenRegister] = useState(false);

  let [gambar, setGambar] = useState(null);
  let [arrayImage, setArrayImage] = useState([]);
  let [arrayImageUrl, setArrayImageUrl] = useState([]);
  let arrayImageSubmitted = [];
  const [invalidImage, setinvalidImage] = useState(null);

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
  ];

  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const [openDelete, setOpenDelete] = useState(false);

  const classes = useStyles();

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const handleClickOpenDelete = () => {
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTermRegister(query);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleClickOpenRegister = () => {
    setOpenRegister(true);
  };

  const handleCloseRegister = () => {
    setOpenRegister(false);
  };

  const handleEraserClick = () => {
    setEraseMode(true);
    canvasRef.current?.eraseMode(true);
  };

  const handlePenClick = () => {
    setEraseMode(false);
    canvasRef.current?.eraseMode(false);
  };

  const handleUndoClick = () => {
    canvasRef.current?.undo();
  };

  const handleRedoClick = () => {
    canvasRef.current?.redo();
  };

  const handleClearClick = () => {
    canvasRef.current?.clearCanvas();
  };

  const handleResetClick = () => {
    canvasRef.current?.resetCanvas();
  };

  const handleEraserClickDenahLokasiSurvey = () => {
    setEraseModeDenahLokasiSurvey(true);
    canvasRefDenahLokasiSurvey.current?.eraseMode(true);
  };

  const handlePenClickDenahLokasiSurvey = () => {
    setEraseModeDenahLokasiSurvey(false);
    canvasRefDenahLokasiSurvey.current?.eraseMode(false);
  };

  const handleUndoClickDenahLokasiSurvey = () => {
    canvasRefDenahLokasiSurvey.current?.undo();
  };

  const handleRedoClickDenahLokasiSurvey = () => {
    canvasRefDenahLokasiSurvey.current?.redo();
  };

  const handleClearClickDenahLokasiSurvey = () => {
    canvasRefDenahLokasiSurvey.current?.clearCanvas();
  };

  const handleResetClickDenahLokasiSurvey = () => {
    canvasRefDenahLokasiSurvey.current?.resetCanvas();
  };

  const jenisKelaminOption = ["LAKI-LAKI", "PEREMPUAN"];
  const agamaOption = [
    "ISLAM",
    "PROTESTAN",
    "KATOLIK",
    "HINDU",
    "BUDHA",
    "KHONGHUCU",
    "LAIN",
  ];
  const statusPerkawinanOption = [
    "BELUM MENIKAH",
    "(JANDA/DUDA)",
    "MENIKAH",
    "MENIKAH / ISTRI",
    "MENIKAH / SUAMI",
  ];
  const kewarganegaraanOption = ["WNI", "WNA"];
  let kelurahanOptions = kelurahans.map((kelurahan) => ({
    label: `${kelurahan.id} - ${kelurahan.namaKelurahan}`,
  }));
  let kecamatanOptions = kecamatans.map((kecamatan) => ({
    label: `${kecamatan.id} - ${kecamatan.namaKecamatan}`,
  }));
  let kabupatenOptions = kabupatens.map((kabupaten) => ({
    label: `${kabupaten.id} - ${kabupaten.namaKabupaten}`,
  }));
  let provinsiOptions = provinsis.map((provinsi) => ({
    label: `${provinsi.id} - ${provinsi.namaProvinsi}`,
  }));
  let marketingOptions = marketings.map((marketing) => ({
    label: `${marketing.kodeMarketing} - ${marketing.namaMarketing}`,
  }));
  let surveyorOptions = surveyors.map((surveyor) => ({
    label: `${surveyor.kodeSurveyor} - ${surveyor.namaSurveyor}`,
  }));
  let tipeOptions = tipes.map((tipe) => ({
    label: `${tipe.kodeTipe} | ${tipe.namaTipe}`,
  }));

  useEffect(() => {
    getUrlImg();
  }, [arrayImage]);

  useEffect(() => {
    getSurveyFidusiaById();
    getAreaData();
    getMarketingsData();
    getSurveyorsData();
    getTipesData();
    getWarnasData();
  }, []);

  useEffect(() => {
    getRegistersData();
  }, [page, searchTermRegister]);

  const getUrlImg = () => {
    let tempArrayImageUrl = [];
    Object.keys(arrayImage).map(function (key, index) {
      tempArrayImageUrl.push(URL.createObjectURL(arrayImage[key]));
      setArrayImageUrl(tempArrayImageUrl);
    });
  };

  const getSurveyFidusiaById = async () => {
    if (id) {
      const response = await axios.post(`${tempUrl}/surveyFidusias/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setRegisterFidusiaId(response.data.registerfidusia.id);
      setCustomerId(response.data.registerfidusia.customer.id);
      setCif(response.data.registerfidusia.customer.cifCustomer);
      setNikCustomer(response.data.registerfidusia.customer.nikCustomer);
      setNoKkCustomer(response.data.registerfidusia.customer.noKkCustomer);
      setNamaCustomer(response.data.registerfidusia.customer.namaCustomer);
      setNamaPanggilanCustomer(
        response.data.registerfidusia.customer.namaPanggilanCustomer
      );
      setTempatLahirCustomer(
        response.data.registerfidusia.customer.tempatLahirCustomer
      );
      setTanggalLahirCustomer(
        new Date(response.data.registerfidusia.customer.tanggalLahirCustomer)
      );
      setJenisKelaminCustomer(
        response.data.registerfidusia.customer.jenisKelaminCustomer
      );
      setAgamaCustomer(response.data.registerfidusia.customer.agamaCustomer);
      setNoTeleponCustomer(
        response.data.registerfidusia.customer.noTeleponCustomer
      );
      setAlamatCustomer(response.data.registerfidusia.customer.alamatCustomer);
      setAlamatTTCustomer(
        response.data.registerfidusia.customer.alamatTTCustomer
      );
      setKodeProvinsi(response.data.registerfidusia.customer.provinsis.id);
      setKodeProvinsiTT(response.data.registerfidusia.customer.provinsisTT.id);
      setKodeKabupaten(response.data.registerfidusia.customer.kabupaten.id);
      setKodeKabupatenTT(response.data.registerfidusia.customer.kabupatenTT.id);
      setKodeKecamatan(response.data.registerfidusia.customer.kecamatan.id);
      setKodeKecamatanTT(response.data.registerfidusia.customer.kecamatanTT.id);
      setKodeKelurahan(response.data.registerfidusia.customer.kelurahan.id);
      setKodeKelurahanTT(response.data.registerfidusia.customer.kelurahanTT.id);
      setKodePos(response.data.registerfidusia.customer.kelurahan.kodePos);
      setKodePosTT(response.data.registerfidusia.customer.kelurahanTT.kodePos);
      setStatusPerkawinanCustomer(
        response.data.registerfidusia.customer.statusPerkawinanCustomer
      );
      setPekerjaanCustomer(
        response.data.registerfidusia.customer.pekerjaanCustomer
      );
      setKewarganegaraanCustomer(
        response.data.registerfidusia.customer.kewarganegaraanCustomer
      );

      setNamaPerusahaanCustomer(
        response.data.registerfidusia.customer.namaPerusahaanCustomer
      );
      setBidangUsahaCustomer(
        response.data.registerfidusia.customer.bidangUsahaCustomer
      );
      setJabatanCustomer(
        response.data.registerfidusia.customer.jabatanCustomer
      );
      setAlamatPerusahaanCustomer(
        response.data.registerfidusia.customer.alamatPerusahaanCustomer
      );
      setNoTeleponPerusahaanCustomer(
        response.data.registerfidusia.customer.noTeleponPerusahaanCustomer
      );
      setLamaKerjaCustomer(
        response.data.registerfidusia.customer.lamaKerjaCustomer
      );
      setGajiPekerjaanCustomer(
        response.data.registerfidusia.customer.gajiPekerjaanCustomer
      );
      setPendapatanLainCustomer(
        response.data.registerfidusia.customer.pendapatanLainCustomer
      );

      setNikPenjamin(response.data.registerfidusia.nikPenjamin);
      setNoKkPenjamin(response.data.registerfidusia.noKkPenjamin);
      setNamaPenjamin(response.data.registerfidusia.namaPenjamin);
      setTempatLahirPenjamin(response.data.registerfidusia.tempatLahirPenjamin);
      setTanggalLahirPenjamin(
        response.data.registerfidusia.tanggalLahirPenjamin &&
          new Date(response.data.registerfidusia.tanggalLahirPenjamin)
      );
      setJenisKelaminPenjamin(
        response.data.registerfidusia.jenisKelaminPenjamin
      );
      setAgamaPenjamin(response.data.registerfidusia.agamaPenjamin);
      setNoTeleponPenjamin(response.data.registerfidusia.noTeleponPenjamin);
      setAlamatPenjamin(response.data.registerfidusia.alamatPenjamin);
      setKodeProvinsiPenjamin(
        response.data.registerfidusia.provinsisPenjamin
          ? response.data.registerfidusia.provinsisPenjamin.id
          : ""
      );
      setKodeKabupatenPenjamin(
        response.data.registerfidusia.kabupatenPenjamin
          ? response.data.registerfidusia.kabupatenPenjamin.id
          : ""
      );
      setKodeKecamatanPenjamin(
        response.data.registerfidusia.kecamatanPenjamin
          ? response.data.registerfidusia.kecamatanPenjamin.id
          : ""
      );
      setKodeKelurahanPenjamin(
        response.data.registerfidusia.kelurahanPenjamin
          ? response.data.registerfidusia.kelurahanPenjamin.id
          : ""
      );
      setKodePosPenjamin(
        response.data.registerfidusia.kelurahanPenjamin
          ? response.data.registerfidusia.kelurahanPenjamin.kodePos
          : ""
      );
      setStatusPerkawinanPenjamin(
        response.data.registerfidusia.statusPerkawinanPenjamin
      );
      setNamaPerusahaanPenjamin(
        response.data.registerfidusia.namaPerusahaanPenjamin
      );
      setAlamatPerusahaanPenjamin(
        response.data.registerfidusia.alamatPerusahaanPenjamin
      );
      setPekerjaanPenjamin(response.data.registerfidusia.pekerjaanPenjamin);
      setLamaKerjaPenjamin(response.data.registerfidusia.lamaKerjaPenjamin);
      setKewarganegaraanPenjamin(
        response.data.registerfidusia.kewarganegaraanPenjamin
      );
      setHubunganPenjamin(response.data.registerfidusia.hubunganPenjamin);

      setAlamatSamaPenjamin(response.data.registerfidusia.alamatSamaPenjamin);
      setAlamatTTPenjamin(response.data.registerfidusia.alamatTTPenjamin);
      setKodeProvinsiTTPenjamin(
        response.data.registerfidusia.provinsisTTPenjamin
          ? response.data.registerfidusia.provinsisTTPenjamin.id
          : ""
      );
      setKodeKabupatenTTPenjamin(
        response.data.registerfidusia.kabupatenTTPenjamin
          ? response.data.registerfidusia.kabupatenTTPenjamin.id
          : ""
      );
      setKodeKecamatanTTPenjamin(
        response.data.registerfidusia.kecamatanTTPenjamin
          ? response.data.registerfidusia.kecamatanTTPenjamin.id
          : ""
      );
      setKodeKelurahanTTPenjamin(
        response.data.registerfidusia.kelurahanTTPenjamin
          ? response.data.registerfidusia.kelurahanTTPenjamin.id
          : ""
      );
      setKodePosTTPenjamin(
        response.data.registerfidusia.kelurahanTTPenjamin
          ? response.data.registerfidusia.kelurahanTTPenjamin.kodePos
          : ""
      );

      setUangMuka(response.data.registerfidusia.uangMuka);
      setPinjamanAju(response.data.registerfidusia.pinjamanAju);
      setAngPerBulan(response.data.registerfidusia.angPerBulan);
      setTenor(response.data.registerfidusia.tenor);

      // DATA KENDARAAN
      setMerk(response.data.merk);
      setTipe(response.data.tipe);
      setTahun(response.data.tahun);
      setWarna(response.data.warna);
      setIsi(response.data.isi);
      setNopol(response.data.nopol);
      setNoRangka(response.data.noRangka);
      setNoMesin(response.data.noMesin);
      setTglStnk(response.data.tglStnk && new Date(response.data.tglStnk));
      setNoBpkb(response.data.noBpkb);
      setBpkbAN(response.data.bpkbAN);
      setBpkbAlamat(response.data.bpkbAlamat);

      setLinkMapsSurvey(response.data.linkMapsSurvey);

      // DATA REFERENSI
      setNamaRefRegister(response.data.namaRefRegister);
      setAlamatRefRegister(response.data.alamatRefRegister);
      setTeleponRefRegister(response.data.teleponRefRegister);
      setHubunganRefRegister(response.data.hubunganRefRegister);
      // setStatusPerkawinanRefRegister(response.data.statusPerkawinanRefRegister);
      setNamaRef2Register(response.data.namaRef2Register);
      setAlamatRef2Register(response.data.alamatRef2Register);
      setTeleponRef2Register(response.data.teleponRef2Register);
      setHubunganRef2Register(response.data.hubunganRef2Register);
      // setStatusPerkawinanRef2Register(
      //   response.data.statusPerkawinanRef2Register
      // );
      setNamaRef3Register(response.data.namaRef3Register);
      setAlamatRef3Register(response.data.alamatRef3Register);
      setTeleponRef3Register(response.data.teleponRef3Register);
      setHubunganRef3Register(response.data.hubunganRef3Register);
      // setStatusPerkawinanRef3Register(
      //   response.data.statusPerkawinanRef3Register
      // );

      // DATA PINJAMAN
      setHargaOtr(response.data.hargaOtr);
      setTglJtTempo(
        response.data.tglJtTempo && new Date(response.data.tglJtTempo)
      );
      setTujuanPenggunaanDana(response.data.tujuanPenggunaanDana);
      setPendinganPengurusan(response.data.pendinganPengurusan);
      setKodeMarketing(response.data.marketing.kodeMarketing);
      setKodeSurveyor(response.data.surveyor.kodeSurveyor);

      // setKeteranganSurvey(response.data.keteranganSurvey);
      setKeterangan(response.data.keterangan);

      setDenahLokasiSurvey(response.data.denahLokasiSurvey);
      setDenahLokasiSurveyLama(response.data.denahLokasiSurvey);
      setTtdSurvey(response.data.ttdSurvey);
      setTtdSurveyLama(response.data.ttdSurvey);
      setNamaTtdSurvey(response.data.namaTtdSurvey);

      setStatusSurvey(response.data.statusSurvey);
      setTglRejectSurvey(
        response.data.tglRejectSurvey && new Date(response.data.tglRejectSurvey)
      );
      setAlasanRejectSurvey(response.data.alasanRejectSurvey);
      setAlasanPendingSurvey(response.data.alasanPendingSurvey);

      setStatusSurveyManager(response.data.statusSurveyManager);

      const findGambar = await axios.post(
        `${tempUrl}/surveyFidusiaGambarBySurveyFidusiaId`,
        {
          id,
          _id: user.id,
          token: user.token,
        }
      );
      setGambar(findGambar.data);
    }
  };

  const getMarketingsData = async () => {
    const response = await axios.post(`${tempUrl}/marketings`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setMarketings(response.data);
  };

  const getSurveyorsData = async () => {
    const response = await axios.post(`${tempUrl}/surveyors`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setSurveyors(response.data);
  };

  const getTipesData = async () => {
    const response = await axios.post(`${tempUrl}/tipes`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setTipes(response.data);
  };

  const getWarnasData = async (kodeUnit) => {
    const response = await axios.post(`${tempUrl}/warnas`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setWarnas(response.data);
  };

  const getRegistersData = async () => {
    const response = await axios.post(
      `${tempUrl}/registerFidusiasPerCabangBlmSurveyPagination?search_query=${searchTermRegister}&page=${page}&limit=${limit}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setRegisters(response.data.registerFidusias);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const getAreaData = async (kodeUnit) => {
    const allKelurahan = await axios.post(`${tempUrl}/kelurahans`, {
      _id: user.id,
      token: user.token,
    });
    setKelurahans(allKelurahan.data);

    const allKecamatan = await axios.post(`${tempUrl}/kecamatans`, {
      _id: user.id,
      token: user.token,
    });
    setKecamatans(allKecamatan.data);

    const allKabupaten = await axios.post(`${tempUrl}/kabupatens`, {
      _id: user.id,
      token: user.token,
    });
    setKabupatens(allKabupaten.data);

    const allProvinsi = await axios.post(`${tempUrl}/provinsis`, {
      _id: user.id,
      token: user.token,
    });
    setProvinsis(allProvinsi.data);

    // setJenisKelaminCustomer(jenisKelaminOption[0]);
    // setAgamaCustomer(agamaOption[0]);
    // setStatusPerkawinanCustomer(statusPerkawinanOption[0]);
    // setKewarganegaraanCustomer(kewarganegaraanOption[0]);

    // setJenisKelaminPenjamin(jenisKelaminOption[0]);
    // setAgamaPenjamin(agamaOption[0]);
    // setStatusPerkawinanPenjamin(statusPerkawinanOption[0]);
    // setKewarganegaraanPenjamin(kewarganegaraanOption[0]);
  };

  const findKelurahan = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahan(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsi("");
        setKodeKabupaten("");
        setKodeKecamatan("");
        setKodePos("");
        setKodeKelurahan(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsi(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupaten(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatan(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePos(response.data.kodePos);
        setKodeKelurahan(kelurahanId);
      }
    }
  };

  const findKelurahanPenjamin = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahanPenjamin(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsiPenjamin("");
        setKodeKabupatenPenjamin("");
        setKodeKecamatanPenjamin("");
        setKodePosPenjamin("");
        setKodeKelurahanPenjamin(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanPenjamin(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePosPenjamin(response.data.kodePos);
        setKodeKelurahanPenjamin(kelurahanId);
      }
    }
  };

  const findKelurahanTT = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahanTT(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsiTT("");
        setKodeKabupatenTT("");
        setKodeKecamatanTT("");
        if (alamatSama && kodePos.length > 0) {
          setKodePosTT(kodePos);
        } else {
          setKodePosTT("");
        }
        setKodeKelurahanTT(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTT(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTT(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePosTT(response.data.kodePos);
        setKodeKelurahanTT(kelurahanId);
      }
    }
  };

  const findKelurahanTTPenjamin = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahanTTPenjamin(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsiTTPenjamin("");
        setKodeKabupatenTTPenjamin("");
        setKodeKecamatanTTPenjamin("");
        if (alamatSama && kodePos.length > 0) {
          setKodePosTTPenjamin(kodePos);
        } else {
          setKodePosTTPenjamin("");
        }
        setKodeKelurahanTTPenjamin(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTTPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTTPenjamin(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePosTTPenjamin(response.data.kodePos);
        setKodeKelurahanTTPenjamin(kelurahanId);
      }
    }
  };

  const findKecamatan = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatan(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsi("");
        setKodeKabupaten("");
        setKodeKecamatan(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsi(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupaten(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatan(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKecamatanPenjamin = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatan(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsiPenjamin("");
        setKodeKabupatenPenjamin("");
        setKodeKecamatanPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKecamatanTT = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatanTT(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsiTT("");
        setKodeKabupatenTT("");
        setKodeKecamatanTT(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTT(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTT(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKecamatanTTPenjamin = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatanTTPenjamin(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsiTTPenjamin("");
        setKodeKabupatenTTPenjamin("");
        setKodeKecamatanTTPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTTPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTTPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKabupaten = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupaten(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsi("");
        setKodeKabupaten(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsi(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupaten(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findKabupatenPenjamin = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupatenPenjamin(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsiPenjamin("");
        setKodeKabupatenPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findKabupatenTT = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupatenTT(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsiTT("");
        setKodeKabupatenTT(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTT(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findKabupatenTTPenjamin = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupatenTTPenjamin(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsiTTPenjamin("");
        setKodeKabupatenTTPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTTPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findProvinsi = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsi(provinsiId);
      if (response.data) {
        setKodeProvinsi(`${response.data.id} - ${response.data.namaProvinsi}`);
      }
    }
  };

  const findProvinsiPenjamin = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsiPenjamin(provinsiId);
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.id} - ${response.data.namaProvinsi}`
        );
      }
    }
  };

  const findProvinsiTT = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsiTT(provinsiId);
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.id} - ${response.data.namaProvinsi}`
        );
      }
    }
  };

  const findProvinsiTTPenjamin = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsiTTPenjamin(provinsiId);
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.id} - ${response.data.namaProvinsi}`
        );
      }
    }
  };

  const findTipe = async (id) => {
    id = id.split(" |", 1)[0];
    if (id) {
      const response = await axios.post(`${tempUrl}/tipeByKodeTipe`, {
        kodeTipe: id,
        _id: user.id,
        token: user.token,
      });
      setTipe(id);
      setNoRangka(response.data.noRangka);
      setMerk(response.data.merk);
      setIsi(response.data.isi);
      setNoMesin(response.data.noMesin);
    }
  };

  const batalSurveyFidusia = async () => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/batalSurveyFidusia/${id}`, {
        customerId,
        kodeCabang: user.cabang.id,
        userIdUpdate: user.id,
        _id: user.id,
        token: user.token,
      });
      setIsReject(false);
      setIsPending(false);
      getSurveyFidusiaById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const accSurveyFidusia = async () => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/accSurveyFidusia/${id}`, {
        customerId,
        kodeCabang: user.cabang.id,
        userIdUpdate: user.id,
        _id: user.id,
        token: user.token,
      });
      setIsReject(false);
      setIsPending(false);
      getSurveyFidusiaById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const rejectSurveyFidusia = async () => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/rejectSurveyFidusia/${id}`, {
        customerId,
        tglRejectSurvey,
        alasanRejectSurvey,
        kodeCabang: user.cabang.id,
        userIdUpdate: user.id,
        _id: user.id,
        token: user.token,
      });
      setIsReject(false);
      setIsPending(false);
      getSurveyFidusiaById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const pendingSurveyFidusia = async () => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/pendingSurveyFidusia/${id}`, {
        customerId,
        alasanPendingSurvey,
        kodeCabang: user.cabang.id,
        userIdUpdate: user.id,
        _id: user.id,
        token: user.token,
      });
      setIsReject(false);
      setIsPending(false);
      getSurveyFidusiaById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const hapusGambar = async (img, i) => {
    if (window.confirm(`Yakin ingin menghapus gambar?`) == false) {
      return;
    }

    let tempGambar = gambar.filter((val) => {
      return val.linkGambar !== img.linkGambar;
    });

    setGambar(tempGambar);

    if (img.linkGambar && img.linkGambar !== "") {
      let image = firebase.storage().refFromURL(img.linkGambar);

      image
        .delete()
        .then(function () {
          console.log("image deleted");
        })
        .catch(function (error) {
          // An error occurred!
          console.log("an error occurred");
        });
    }

    // Delete Gambar
    try {
      await axios.post(`${tempUrl}/deleteSurveyFidusiaGambar/${img.id}`, {
        kodeCabang: user.cabang.id,
        userIdInput: user.id,
        _id: user.id,
        token: user.token,
      });
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      console.log(error);
    }
  };

  const ubahSurveyFidusia = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    function base64ToBlob(base64, contentType = "image/png") {
      const byteCharacters = atob(base64.split(",")[1]);
      const byteArrays = [];

      for (let i = 0; i < byteCharacters.length; i += 512) {
        const slice = byteCharacters.slice(i, i + 512);
        const byteNumbers = new Array(slice.length);
        for (let j = 0; j < slice.length; j++) {
          byteNumbers[j] = slice.charCodeAt(j);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, { type: contentType });
    }

    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeKelurahan.length !== 0 &&
      kodeKelurahanTT.length !== 0 &&
      kodeMarketing.length !== 0 &&
      kodeSurveyor.length !== 0
    ) {
      setLoading(true);
      try {
        setLoading(true);
        console.log("In 1");

        let tempTtdSurvey = ttdSurvey;

        console.log("In 2");
        if (tempTtdSurvey.length === 0) {
          if (!canvasRef.current) return;
          canvasRef.current
            .exportImage("png")
            .then(async (data) => {
              // console.log(data);
              const blob = base64ToBlob(data);
              const storage = getStorage();
              const imgRef = ref(storage, `signatures/${Date.now()}.png`);
              await uploadBytes(imgRef, blob);
              const url = await getDownloadURL(imgRef);
              console.log("Uploaded tempTtdSurvey:", url);
              tempTtdSurvey = url;
            })
            .catch((e) => {
              console.error(e);
            });

          if (ttdSurveyLama !== "") {
            // Hapus Gambar Lama
            let image = firebase.storage().refFromURL(ttdSurveyLama);
            image
              .delete()
              .then(function () {
                console.log("image deleted");
              })
              .catch(function (error) {
                // An error occurred!
                console.log("an error occurred");
              });
          }
        }
        console.log("In 3");

        let tempDenahLokasiSurvey = denahLokasiSurvey;

        console.log("In 4");
        console.log("denahLokasiSurveyLama");
        console.log(denahLokasiSurveyLama);
        if (tempDenahLokasiSurvey.length === 0) {
          if (!canvasRefDenahLokasiSurvey.current) return;
          canvasRefDenahLokasiSurvey.current
            .exportImage("png")
            .then(async (data) => {
              // console.log(data);
              const blob = base64ToBlob(data);
              const storage = getStorage();
              const imgRef = ref(storage, `signatures/${Date.now()}.png`);
              await uploadBytes(imgRef, blob);
              const url = await getDownloadURL(imgRef);
              console.log("Uploaded tempDenahLokasiSurvey:", url);
              tempDenahLokasiSurvey = url;
            })
            .catch((e) => {
              console.error(e);
            });

          if (denahLokasiSurveyLama !== "") {
            // Hapus Gambar Lama
            let image = firebase.storage().refFromURL(denahLokasiSurveyLama);
            image
              .delete()
              .then(function () {
                console.log("image deleted");
              })
              .catch(function (error) {
                // An error occurred!
                console.log("an error occurred");
              });
          }
        }
        console.log("In 5");

        while (tempTtdSurvey.length === 0 || tempDenahLokasiSurvey === 0) {
          await new Promise((res) => setTimeout(res, 1000));
        }
        console.log("In 6");
        // console.log("ttdSurvey");
        // console.log(ttdSurvey);
        // console.log("tempTtdSurvey");
        // console.log(tempTtdSurvey);
        // console.log("denahLokasiSurvey");
        // console.log(denahLokasiSurvey);
        // console.log("tempDenahLokasiSurvey");
        // console.log(tempDenahLokasiSurvey);

        for (let tempGambarLama of gambar) {
          arrayImageSubmitted.push(tempGambarLama);
        }

        // console.log("arrayImage");
        // console.log(arrayImage);

        // Convert FileList to an array
        const imageArray = Array.from(arrayImage);

        console.log("In 7");
        const uploadPromises = imageArray.map(async (selectedFile, index) => {
          if (!selectedFile) return null;

          const storageRef = firebase.storage().ref();
          const fileRef = storageRef.child(
            `${Math.floor(Math.random() * 1000 + 1)}${selectedFile.name}`
          );

          await fileRef.put(selectedFile);
          const downloadURL = await fileRef.getDownloadURL();
          // console.log(`Upload ${index + 1}:`, downloadURL);

          return downloadURL;
        });

        console.log("In 8");
        // Wait for all uploads to finish
        const uploadedLinks = await Promise.all(uploadPromises);

        // Now the uploadedLinks array is in order
        // console.log("Final ordered links:", uploadedLinks);

        console.log("In 9");
        for (let link of uploadedLinks) {
          await axios.post(`${tempUrl}/saveSurveyFidusiaGambar`, {
            surveyFidusiaId: id,
            linkGambar: link,
            kodeCabang: user.cabang.id,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
          });
        }

        console.log("In 10");
        // Set the submitted images in order
        arrayImageSubmitted.push(...uploadedLinks);

        console.log("In 11");
        await axios.post(`${tempUrl}/ubahSurveyFidusia`, {
          registerFidusiaData: {
            registerFidusiaId,
            customerId,
            nikCustomer,
            noKkCustomer,
            namaCustomer,
            namaPanggilanCustomer,
            tempatLahirCustomer,
            tanggalLahirCustomer,
            jenisKelaminCustomer,
            agamaCustomer,
            noTeleponCustomer,
            alamatCustomer,
            alamatTTCustomer,
            kelurahanTTId: kodeKelurahanTT,
            statusPerkawinanCustomer,
            pekerjaanCustomer,
            kewarganegaraanCustomer,

            kelurahanId: kodeKelurahan,
            provinsiId: kodeProvinsi.split(" ", 1)[0],
            kabupatenId: kodeKabupaten.split(" ", 1)[0],
            kecamatanId: kodeKecamatan.split(" ", 1)[0],

            ketProvinsi,
            ketKabupaten,
            ketKecamatan,
            ketKelurahan,
            kodePos,

            kelurahanTTId: kodeKelurahanTT.split(" ", 1)[0],
            provinsiTTId: kodeProvinsiTT.split(" ", 1)[0],
            kabupatenTTId: kodeKabupatenTT.split(" ", 1)[0],
            kecamatanTTId: kodeKecamatanTT.split(" ", 1)[0],

            ketProvinsiTT,
            ketKabupatenTT,
            ketKecamatanTT,
            ketKelurahanTT,
            kodePosTT,

            namaPerusahaanCustomer,
            bidangUsahaCustomer,
            jabatanCustomer,
            alamatPerusahaanCustomer,
            noTeleponPerusahaanCustomer,
            lamaKerjaCustomer,
            gajiPekerjaanCustomer,
            pendapatanLainCustomer,

            // Data Penjamin
            nikPenjamin,
            noKkPenjamin,
            namaPenjamin,
            tempatLahirPenjamin,
            tanggalLahirPenjamin,
            jenisKelaminPenjamin,
            agamaPenjamin,
            noTeleponPenjamin,
            alamatPenjamin,
            statusPerkawinanPenjamin,
            namaPerusahaanPenjamin,
            alamatPerusahaanPenjamin,
            pekerjaanPenjamin,
            lamaKerjaPenjamin,
            kewarganegaraanPenjamin,
            hubunganPenjamin,

            kelurahanIdPenjamin: kodeKelurahanPenjamin.split(" ", 1)[0],
            provinsiIdPenjamin: kodeProvinsiPenjamin.split(" ", 1)[0],
            kabupatenIdPenjamin: kodeKabupatenPenjamin.split(" ", 1)[0],
            kecamatanIdPenjamin: kodeKecamatanPenjamin.split(" ", 1)[0],

            ketProvinsiPenjamin,
            ketKabupatenPenjamin,
            ketKecamatanPenjamin,
            ketKelurahanPenjamin,
            kodePosPenjamin,

            alamatTTPenjamin,
            kelurahanTTIdPenjamin: kodeKelurahanTTPenjamin.split(" ", 1)[0],
            provinsiTTIdPenjamin: kodeProvinsiTTPenjamin.split(" ", 1)[0],
            kabupatenTTIdPenjamin: kodeKabupatenTTPenjamin.split(" ", 1)[0],
            kecamatanTTIdPenjamin: kodeKecamatanTTPenjamin.split(" ", 1)[0],

            ketProvinsiTTPenjamin,
            ketKabupatenTTPenjamin,
            ketKecamatanTTPenjamin,
            ketKelurahanTTPenjamin,
            kodePosTTPenjamin,

            uangMuka,
            pinjamanAju,
            angPerBulan,
            tenor,

            merk,
            tipe,
            tahun,
            warna,
            nopol,
            keterangan,

            isSurvey: true,

            userIdUpdate: user.id,
          },
          surveyFidusiaData: {
            surveyFidusiaId: id,
            registerFidusiaId,

            linkMapsSurvey,

            // DATA REFERENSI
            namaRefRegister,
            alamatRefRegister,
            teleponRefRegister,
            hubunganRefRegister,
            // statusPerkawinanRefRegister,
            namaRef2Register,
            alamatRef2Register,
            teleponRef2Register,
            hubunganRef2Register,
            // statusPerkawinanRef2Register,
            namaRef3Register,
            alamatRef3Register,
            teleponRef3Register,
            hubunganRef3Register,
            // statusPerkawinanRef3Register,

            // DATA PINJAMAN
            hargaOtr,
            uangMuka,
            pinjamanAju,
            angPerBulan,
            tenor,
            tglJtTempo,
            tujuanPenggunaanDana,
            pendinganPengurusan,
            kodeMarketing,
            kodeSurveyor,

            // DATA KENDARAAN
            merk,
            tipe,
            tahun,
            warna,
            isi,
            nopol,
            noRangka,
            noMesin,
            tglStnk,
            noBpkb,
            bpkbAN,
            bpkbAlamat,

            keterangan,

            namaTtdSurvey,

            ttdSurvey: tempTtdSurvey,
            denahLokasiSurvey: tempDenahLokasiSurvey,

            kodeCabang: user.cabang.id,
            userIdInput: user.id,
          },

          kodeCabang: user.cabang.id,
          userIdInput: user.id,
          _id: user.id,
          token: user.token,
        });
        console.log("In 12");
        setLoading(false);
        navigate("/surveyFidusia");
      } catch (error) {
        console.log(error);
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const hapusSurveyFidusia = async (id) => {
    setLoading(true);
    try {
      if (ttdSurvey !== "") {
        // Hapus Gambar Lama
        let imageTtdSurvey = firebase.storage().refFromURL(ttdSurvey);
        imageTtdSurvey
          .delete()
          .then(function () {
            console.log("image ttdSurvey deleted");
          })
          .catch(function (error) {
            // An error occurred!
            console.log("an error occurred");
          });
      }

      if (denahLokasiSurvey !== "") {
        let imageDenahLokasiSurvey = firebase
          .storage()
          .refFromURL(denahLokasiSurvey);
        imageDenahLokasiSurvey
          .delete()
          .then(function () {
            console.log("image denahLokasiSurvey deleted");
          })
          .catch(function (error) {
            // An error occurred!
            console.log("an error occurred");
          });
      }

      await axios.post(`${tempUrl}/hapusSurveyFidusia/${id}`, {
        customerId,
        registerFidusiaId,
        _id: user.id,
        token: user.token,
      });
      setNikCustomer("");
      setNoKkCustomer("");
      setCif("");
      setNamaCustomer("");
      setNamaPanggilanCustomer("");
      setTempatLahirCustomer("");
      setTanggalLahirCustomer("");
      setJenisKelaminCustomer("");
      setAgamaCustomer("");
      setNoTeleponCustomer("");
      setAlamatCustomer("");
      setKodeProvinsi("");
      setKodeKabupaten("");
      setKodeKecamatan("");
      setKodeKelurahan("");
      setKodePos("");
      setStatusPerkawinanCustomer("");
      setPekerjaanCustomer("");
      setKewarganegaraanCustomer("");

      setNamaPerusahaanCustomer("");
      setBidangUsahaCustomer("");
      setJabatanCustomer("");
      setAlamatPerusahaanCustomer("");
      setNoTeleponPerusahaanCustomer("");
      setLamaKerjaCustomer("");
      setGajiPekerjaanCustomer("");
      setPendapatanLainCustomer("");

      setNikPenjamin("");
      setNoKkPenjamin("");
      setNamaPenjamin("");
      setTempatLahirPenjamin("");
      setTanggalLahirPenjamin("");
      setJenisKelaminPenjamin("");
      setAgamaPenjamin("");
      setNoTeleponPenjamin("");
      setAlamatPenjamin("");
      setKodeProvinsiPenjamin("");
      setKodeKabupatenPenjamin("");
      setKodeKecamatanPenjamin("");
      setKodeKelurahanPenjamin("");
      setKodePosPenjamin("");
      setStatusPerkawinanPenjamin("");
      setNamaPerusahaanPenjamin("");
      setAlamatPerusahaanPenjamin("");
      setPekerjaanPenjamin("");
      setLamaKerjaPenjamin("");
      setKewarganegaraanPenjamin("");
      setHubunganPenjamin("");

      setAlamatSamaPenjamin("");
      setAlamatTTPenjamin("");
      setKodeProvinsiTTPenjamin("");
      setKodeKabupatenTTPenjamin("");
      setKodeKecamatanTTPenjamin("");
      setKodeKelurahanTTPenjamin("");
      setKodePosTTPenjamin("");

      setUangMuka("");
      setPinjamanAju("");
      setAngPerBulan("");
      setTenor("");

      // DATA KENDARAAN
      setMerk("");
      setTipe("");
      setTahun("");
      setWarna("");
      setIsi("");
      setNopol("");
      setNoRangka("");
      setNoMesin("");
      setTglStnk("");
      setNoBpkb("");
      setBpkbAN("");
      setBpkbAlamat("");

      setLinkMapsSurvey("");

      // DATA REFERENSI
      setNamaRefRegister("");
      setAlamatRefRegister("");
      setTeleponRefRegister("");
      setHubunganRefRegister("");
      // setStatusPerkawinanRefRegister("");
      setNamaRef2Register("");
      setAlamatRef2Register("");
      setTeleponRef2Register("");
      setHubunganRef2Register("");
      // setStatusPerkawinanRef2Register("");
      setNamaRef3Register("");
      setAlamatRef3Register("");
      setTeleponRef3Register("");
      setHubunganRef3Register("");
      // setStatusPerkawinanRef3Register("");

      // DATA PINJAMAN
      setHargaOtr("");
      setTglJtTempo("");
      setTujuanPenggunaanDana("");
      setPendinganPengurusan("");
      setKodeMarketing("");
      setKodeSurveyor("");

      setKeterangan("");

      setDenahLokasiSurvey("");
      setTtdSurvey("");
      setNamaTtdSurvey("");
      navigate("/surveyFidusia");
      setPreviewPdfFormulir(false);
      setOpen(false);
    } catch (error) {
      if (error.response.data.registerfidusia.message.includes("foreign key")) {
        alert(`${cif} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "FormulirPermohonanAkadKredit",
  });

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Fidusia</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Survey Fidusia</h5>
      <hr />

      <Box sx={spacingTop}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => navigate(`/surveyFidusia`)}
          sx={{ marginRight: 2 }}
        >
          {"< Kembali"}
        </Button>
      </Box>

      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              setPreviewPdfFormulir(!previewPdfFormulir);
            }}
          >
            FORMULIR
          </Button>
        </ButtonGroup>
      </Box>

      {previewPdfFormulir && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={generatePDF}
          >
            CETAK
          </Button>
          <div ref={reportTemplateRef} style={cetakContainer}>
            {/* Halaman 1 */}
            <div style={cetakPage}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={LogoPerusahaanSpFidusiaBlackAndWhite}
                  alt="LogoPerusahaanSpFidusiaBlackAndWhite"
                  style={{ width: "400px" }}
                />
              </div>
              <p style={cetakCenter}>FORMULIR PERMOHONAN AKAD KREDIT</p>

              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEMOHON</b>
                    </div>
                    <div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Lengkap (Sesuai KTP)</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Identitas</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Panggilan</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Tempat /Tanggal Lahir</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Status</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Jumlah Tanggungan</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Alamat KTP</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {namaCustomer && namaCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {nikCustomer && nikCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {namaPanggilanCustomer &&
                                  namaPanggilanCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {tempatLahirCustomer &&
                                  tempatLahirCustomer.slice(0, 24)}
                                , {formatDate(tanggalLahirCustomer)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {statusPerkawinanCustomer &&
                                  statusPerkawinanCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {alamatCustomer && alamatCustomer.slice(0, 30)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatCustomer && alamatCustomer.slice(30, 30 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatCustomer &&
                            alamatCustomer.slice(30 + 65, 30 + 65 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Alamat Sekarang</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {alamatTTCustomer &&
                                  alamatTTCustomer.slice(0, 30)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatTTCustomer &&
                            alamatTTCustomer.slice(30, 30 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatTTCustomer &&
                            alamatTTCustomer.slice(30 + 65, 30 + 65 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Telp/HP 1</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Telp/HP 2</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Gadis Ibu Kandung</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {noTeleponCustomer &&
                                  noTeleponCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEKERJAAN</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Perusahaan/Usaha</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Bidang Usaha</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Bagian/Jabatan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Perusahaan/Usaha</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaPerusahaanCustomer &&
                                namaPerusahaanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {bidangUsahaCustomer &&
                                bidangUsahaCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {jabatanCustomer && jabatanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPerusahaanCustomer &&
                                alamatPerusahaanCustomer.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatPerusahaanCustomer &&
                          alamatPerusahaanCustomer.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatPerusahaanCustomer &&
                          alamatPerusahaanCustomer.slice(30 + 65, 30 + 65 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp Perusahaan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Lama Kerja / Status</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPerusahaanCustomer}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {lamaKerjaCustomer &&
                                lamaKerjaCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            height: "104px",
                            border: "1px solid black",
                            paddingTop: "40px",
                          }}
                        >
                          <p style={textStyle}>Besaran Gaji dalam setahun</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"< 50 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"50 Juta - 75 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"75 Juta - 100 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"> 100 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pendapatan Lain</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Atasan Langsung</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Atasan</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {pendapatanLainCustomer.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}></p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pekerjaan/Alamat</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPerusahaanCustomer &&
                                noTeleponPerusahaanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPerusahaanCustomer &&
                                alamatPerusahaanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>
                </div>
                <div style={{ flex: 1, marginLeft: "20px" }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA KENDARAAN</b>
                    </div>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Merek</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Type</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Tahun</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Warna</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>No. Polisi</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>No. Rangka</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>No. Mesin</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Masa Berlaku STNK</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Nama BPKB</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Alamat BPKB</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{merk && merk.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{tipe && tipe.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{tahun && tahun.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{warna && warna.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{nopol && nopol.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {noRangka && noRangka.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {noMesin && noMesin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{formatDate(tglStnk)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {bpkbAN && bpkbAN.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {bpkbAlamat && bpkbAlamat.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}></p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}></p>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEMBIAYAAN / STRUKTUR KREDIT</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Harga OTR</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Uang Muka</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pokok Hutang</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Angsuran</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Jangka Waktu</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Tanggal Jatuh Tempo</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Tujuan Penggunaan Dana</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pendingan/Pengurusan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Sumber Order</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Surveyor</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {hargaOtr.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {uangMuka.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {pinjamanAju.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {angPerBulan.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tenor.toLocaleString("de-DE")} BULAN
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tglJtTempo && tglJtTempo.getDate()} SETIAP BULAN
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tujuanPenggunaanDana &&
                                tujuanPenggunaanDana.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {pendinganPengurusan &&
                                pendinganPengurusan.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {kodeMarketing && kodeMarketing.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {kodeSurveyor && kodeSurveyor.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PENJAMIN</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Identitas</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Lengkap (Sesuai KTP)</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Tempat /Tanggal Lahir</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Sekarang</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {nikPenjamin && nikPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaPenjamin && namaPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tempatLahirPenjamin &&
                                tempatLahirPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPenjamin &&
                                noTeleponPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPenjamin && alamatPenjamin.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPenjamin && alamatPenjamin.slice(30, 30 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPenjamin &&
                        alamatPenjamin.slice(30 + 65, 30 + 65 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Nama Perusahaan/Usaha</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Alamat Perusahaan/Usaha</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {namaPerusahaanPenjamin &&
                              namaPerusahaanPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {alamatPerusahaanPenjamin &&
                              alamatPerusahaanPenjamin.slice(0, 30)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPerusahaanPenjamin &&
                        alamatPerusahaanPenjamin.slice(30, 30 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPerusahaanPenjamin &&
                        alamatPerusahaanPenjamin.slice(30 + 65, 30 + 65 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Bagian/Jabatan</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Lama Kerja</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Hubungan Penjamin</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {pekerjaanPenjamin &&
                              pekerjaanPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {lamaKerjaPenjamin &&
                              lamaKerjaPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {hubunganPenjamin && hubunganPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div>
                  <div style={cetakTitle}>
                    <b>KETERANGAN LAIN</b>
                  </div>
                </div>
                <div style={{ border: "1px solid black", height: "120px" }}>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(0, 135)}
                  </p>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(135, 270)}
                  </p>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(270, 405)}
                  </p>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(405, 540)}
                  </p>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div style={{ fontSize: "10px", fontWeight: "bold" }}>
                  <p style={textStyle}>
                    Catatan : Apabila Permohonan sudah disetujui Pemohon dan
                    Penjamin bersedia dan sanggup
                  </p>
                  <div style={{ marginLeft: "80px" }}>
                    <p style={textStyle}>
                      mentaati segala peraturan dan perjanjian yang telah
                      ditetapkan oleh perusahaan
                    </p>
                  </div>
                  <p style={textStyle}>* Coret yang tidak perlu</p>
                </div>
              </div>
            </div>

            {/* Halaman 2 */}
            <div style={cetakPage}>
              <div style={{ marginTop: "20px" }}>
                <p style={cetakCenter}>DENAH NASABAH & DATA REFERENSI</p>
              </div>

              <div style={{ display: "flex", marginTop: "20px" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA REFERENSI</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Hubungan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Status</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Tempat Tinggal</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaRefRegister && namaRefRegister.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {hubunganRefRegister &&
                                hubunganRefRegister.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {/* {statusPerkawinanRefRegister &&
                                statusPerkawinanRefRegister.slice(0, 36)} */}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatRefRegister &&
                                alamatRefRegister.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatRefRegister &&
                          alamatRefRegister.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {teleponRefRegister &&
                                teleponRefRegister.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA REFERENSI</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Hubungan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Status</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Tempat Tinggal</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaRef3Register &&
                                namaRef3Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {hubunganRef3Register &&
                                hubunganRef3Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {/* {statusPerkawinanRef3Register &&
                                statusPerkawinanRef3Register.slice(0, 36)} */}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatRef3Register &&
                                alamatRef3Register.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatRef3Register &&
                          alamatRef3Register.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {teleponRef3Register &&
                                teleponRef3Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>
                </div>
                <div style={{ flex: 1, marginLeft: "20px" }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA REFERENSI</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Hubungan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Status</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Tempat Tinggal</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaRef2Register &&
                                namaRef2Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {hubunganRef2Register &&
                                hubunganRef2Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {/* {statusPerkawinanRef2Register &&
                                statusPerkawinanRef2Register.slice(0, 36)} */}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatRef2Register &&
                                alamatRef2Register.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatRef2Register &&
                          alamatRef2Register.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {teleponRef2Register &&
                                teleponRef2Register.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  marginTop: "40px",
                  marginBottom: "20px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <p style={textStyle}>{keteranganSurvey}</p>
              </div>

              <div style={{ marginLeft: "600px", fontWeight: "bold" }}>
                <div style={{ display: "flex" }}>
                  <p style={textStyle}>Batam,</p>
                  <div
                    style={{
                      marginLeft: "20px",
                      borderBottom: "1px solid black",
                      width: "160px",
                    }}
                  ></div>
                </div>
                <div style={{ marginLeft: "75px" }}>
                  <p style={textStyle}>Hormat Saya</p>
                </div>
                <div style={{ height: "100px", marginLeft: "75px" }}>
                  <img
                    src={ttdSurvey}
                    alt="Base64 Image"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "75px",
                    borderBottom: "1px solid black",
                    width: "160px",
                  }}
                >
                  <p style={textStyle}>Nama</p>
                </div>
                <div style={{ marginLeft: "75px" }}>
                  <p style={textStyle}>Pemohon</p>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div style={{ height: "300px" }}>
                  <img
                    src={denahLokasiSurvey}
                    alt="Base64 Image"
                    style={{ maxWidth: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {statusSurveyManager !== "ACC" && (
        <Box sx={buttonModifierContainer}>
          <ButtonGroup variant="contained">
            <Button
              color="error"
              startIcon={<DeleteOutlineIcon />}
              sx={{ textTransform: "none" }}
              onClick={handleClickOpenDelete}
            >
              Hapus
            </Button>
          </ButtonGroup>
        </Box>
      )}

      <Box sx={buttonModifierContainer}>
        <ButtonGroup variant="contained">
          {(statusSurvey === "ACC" ||
            statusSurvey === "REJECT" ||
            statusSurvey === "PENDING") && (
            <Form onSubmit={batalSurveyFidusia}>
              <Button
                color="primary"
                sx={{ bgcolor: "primary.light", textTransform: "none" }}
                type="submit"
              >
                Batal
              </Button>
            </Form>
          )}
          {statusSurvey !== "ACC" && (
            <Form onSubmit={accSurveyFidusia}>
              <Button
                color="success"
                sx={{ bgcolor: "success.light", textTransform: "none" }}
                type="submit"
              >
                Acc
              </Button>
            </Form>
          )}
          {statusSurvey !== "REJECT" && (
            <Button
              color="error"
              sx={{ bgcolor: "error.light", textTransform: "none" }}
              // onClick={rejectSurveyFidusia}
              onClick={() => {
                setIsReject(!isReject);
                setIsPending(false);
              }}
            >
              Reject
            </Button>
          )}
          {statusSurvey !== "PENDING" && (
            <Button
              color="primary"
              sx={{ bgcolor: "primary.light", textTransform: "none" }}
              // onClick={pendingSurveyFidusia}
              onClick={() => {
                setIsPending(!isPending);
                setIsReject(false);
              }}
            >
              Pending
            </Button>
          )}
        </ButtonGroup>
      </Box>
      {isReject === true && (
        <div style={{ marginTop: "10px" }}>
          <Form noValidate onSubmit={rejectSurveyFidusia}>
            <Paper elevation={6} sx={mainContainer}>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="5" style={textRight}>
                          Tanggal Reject <b style={colorRed}>*</b> :
                        </Form.Label>
                        <Col sm="7">
                          <DatePicker
                            dateFormat="dd/MM/yyyy"
                            selected={tglRejectSurvey}
                            onChange={(e) => setTglRejectSurvey(e)}
                            customInput={
                              <TextField
                                error={
                                  error && tglRejectSurvey === null && true
                                }
                                helperText={
                                  error &&
                                  tglRejectSurvey === null &&
                                  "Tanggal Reject harus diisi!"
                                }
                                sx={{ width: "100%" }}
                                size="small"
                              />
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            Tanggal Reject harus diisi!
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="5" style={textRight}>
                          Alasan Reject :
                        </Form.Label>
                        <Col sm="7">
                          <Form.Control
                            value={alasanRejectSurvey}
                            onChange={(e) =>
                              setAlasanRejectSurvey(e.target.value)
                            }
                            style={{ textTransform: "uppercase" }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Alasan Reject harus diisi!
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Box sx={spacingTop}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Simpan
                    </Button>
                  </Box>
                </Box>
                <Box sx={[showDataWrapper, secondWrapper]}></Box>
              </Box>
            </Paper>
          </Form>
        </div>
      )}
      {isPending === true && (
        <div style={{ marginTop: "10px" }}>
          <Form noValidate onSubmit={pendingSurveyFidusia}>
            <Paper elevation={6} sx={mainContainer}>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="5" style={textRight}>
                          Alasan Pending :
                        </Form.Label>
                        <Col sm="7">
                          <Form.Control
                            value={alasanPendingSurvey}
                            onChange={(e) =>
                              setAlasanPendingSurvey(e.target.value)
                            }
                            style={{ textTransform: "uppercase" }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Alasan Pending harus diisi!
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Box sx={spacingTop}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Simpan
                    </Button>
                  </Box>
                </Box>
                <Box sx={[showDataWrapper, secondWrapper]}></Box>
              </Box>
            </Paper>
          </Form>
        </div>
      )}

      <Form noValidate validated={validated} onSubmit={ubahSurveyFidusia}>
        {/* Customer */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Pribadi Nasabah</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        NIK / CIF :
                      </Form.Label>
                      <Col sm="4">
                        <Form.Control value={nikCustomer} disabled readOnly />
                      </Col>
                      <Col sm="3">
                        <Form.Control disabled value={cif} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        NIK <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={nikCustomer}
                          onChange={(e) => setNikCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. KK :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={noKkCustomer}
                          onChange={(e) => setNoKkCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          required
                          value={namaCustomer}
                          onChange={(e) => setNamaCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Panggilan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={namaPanggilanCustomer}
                          onChange={(e) =>
                            setNamaPanggilanCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tempat Lahir <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={tempatLahirCustomer}
                          onChange={(e) =>
                            setTempatLahirCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Lahir <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control />}
                          selected={tanggalLahirCustomer}
                          onChange={(date) => setTanggalLahirCustomer(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jenis Kelamin <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={jenisKelaminCustomer}
                          onChange={(e) => {
                            setJenisKelaminCustomer(e.target.value);
                          }}
                        >
                          {jenisKelaminOption.map((jenisKelamin) => (
                            <option value={jenisKelamin}>{jenisKelamin}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Agama <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={agamaCustomer}
                          onChange={(e) => {
                            setAgamaCustomer(e.target.value);
                          }}
                        >
                          {agamaOption.map((agama) => (
                            <option value={agama}>{agama}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Telp / HP <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={noTeleponCustomer}
                          onChange={(e) => setNoTeleponCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={statusPerkawinanCustomer}
                          onChange={(e) => {
                            setStatusPerkawinanCustomer(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pekerjaan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={pekerjaanCustomer}
                          onChange={(e) =>
                            setPekerjaanCustomer(e.target.value)} style={{ textTransform: 'uppercase' }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kewarganegaraan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={kewarganegaraanCustomer}
                          onChange={(e) => {
                            setKewarganegaraanCustomer(e.target.value);
                          }}
                        >
                          {kewarganegaraanOption.map((kewarganegaraan) => (
                            <option value={kewarganegaraan}>
                              {kewarganegaraan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Alamat (Identitas) */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Alamat (Identitas)</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          required
                          value={alamatCustomer}
                          onChange={(e) => setAlamatCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kel. / Desa <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kelurahanOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeKelurahan.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKelurahan(value.label.split(" ", 1)[0]);
                            } else {
                              findKelurahan("");
                            }
                          }}
                          value={kodeKelurahan}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          disabled={kodeKelurahan !== "99999999"}
                          value={ketKelurahan}
                          onChange={(e) => setKetKelurahan(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kecamatan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kecamatanOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeKecamatan.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKecamatan(value.label);
                            } else {
                              findKecamatan("");
                            }
                          }}
                          value={kodeKecamatan}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          disabled={kodeKecamatan.split(" ", 1)[0] !== "999999"}
                          value={ketKecamatan}
                          onChange={(e) => setKetKecamatan(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kabupaten / Kota <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kabupatenOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeKabupaten.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKabupaten(value.label);
                            } else {
                              findKabupaten("");
                            }
                          }}
                          value={kodeKabupaten}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          disabled={kodeKabupaten.split(" ", 1)[0] !== "9999"}
                          value={ketKabupaten}
                          onChange={(e) => setKetKabupaten(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Provinsi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={provinsiOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && kodeProvinsi.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findProvinsi(value.label);
                            } else {
                              findProvinsi("");
                            }
                          }}
                          value={kodeProvinsi}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          disabled={kodeProvinsi.split(" ", 1)[0] !== "99"}
                          value={ketProvinsi}
                          onChange={(e) => setKetProvinsi(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode POS <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          type="number"
                          value={kodePos}
                          disabled={
                            kodeKelurahan.split(" ", 1)[0] !== "99999999"
                          }
                          onChange={(e) => setKodePos(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Tempat Tinggal */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Tempat Tinggal</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Card style={{ marginTop: "10px" }}>
                  <Card.Header>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box></Box>
                      <Box>
                        <Form.Check
                          type="checkbox"
                          label="Sama dengan alamat identitas"
                          checked={alamatSama}
                          onChange={() => {
                            setAlamatSama(!alamatSama);
                            if (!alamatSama === true) {
                              setAlamatTTCustomer(alamatCustomer);
                              setKodeKelurahanTT(kodeKelurahan);
                              setKetKelurahanTT(ketKelurahan);
                              setKodeKecamatanTT(kodeKecamatan);
                              setKetKecamatanTT(ketKecamatan);
                              setKodeKabupatenTT(kodeKabupaten);
                              setKetKabupatenTT(ketKabupaten);
                              setKodeProvinsiTT(kodeProvinsi);
                              setKetProvinsiTT(ketProvinsi);
                              setKodePosTT(kodePos);
                            }
                          }}
                        />
                      </Box>
                    </Box>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              required
                              value={alamatTTCustomer}
                              onChange={(e) =>
                                setAlamatTTCustomer(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kelurahanOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error &&
                                    kodeKelurahanTT.length === 0 &&
                                    true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKelurahanTT(value.label.split(" ", 1)[0]);
                                } else {
                                  findKelurahanTT("");
                                }
                              }}
                              value={kodeKelurahanTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              required
                              disabled={
                                kodeKelurahanTT.split(" ", 1)[0] !== "99999999"
                              }
                              value={ketKelurahanTT}
                              onChange={(e) =>
                                setKetKelurahanTT(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kecamatanOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error &&
                                    kodeKecamatanTT.length === 0 &&
                                    true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKecamatanTT(value.label);
                                } else {
                                  findKecamatanTT("");
                                }
                              }}
                              value={kodeKecamatanTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              required
                              disabled={
                                kodeKecamatanTT.split(" ", 1)[0] !== "999999"
                              }
                              value={ketKecamatanTT}
                              onChange={(e) =>
                                setKetKecamatanTT(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kabupatenOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error &&
                                    kodeKabupatenTT.length === 0 &&
                                    true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKabupatenTT(value.label);
                                } else {
                                  findKabupatenTT("");
                                }
                              }}
                              value={kodeKabupatenTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              required
                              disabled={
                                kodeKabupatenTT.split(" ", 1)[0] !== "9999"
                              }
                              value={ketKabupatenTT}
                              onChange={(e) =>
                                setKetKabupatenTT(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={provinsiOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error && kodeProvinsiTT.length === 0 && true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findProvinsiTT(value.label);
                                } else {
                                  findProvinsiTT("");
                                }
                              }}
                              value={kodeProvinsiTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              required
                              disabled={
                                kodeProvinsiTT.split(" ", 1)[0] !== "99"
                              }
                              value={ketProvinsiTT}
                              onChange={(e) => setKetProvinsiTT(e.target.value)}
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              required
                              type="number"
                              value={kodePosTT}
                              disabled={
                                kodeKelurahanTT.split(" ", 1)[0] !== "99999999"
                              }
                              onChange={(e) => setKodePosTT(e.target.value)}
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Lokasi Tempat Tinggal */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Lokasi Tempat Tinggal</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Link Map <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={linkMapsSurvey}
                          onChange={(e) => setLinkMapsSurvey(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Pekerjaan */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Pekerjaan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Perusahaan / Usaha <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={namaPerusahaanCustomer}
                          onChange={(e) =>
                            setNamaPerusahaanCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Bidang Usaha <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={bidangUsahaCustomer}
                          onChange={(e) =>
                            setBidangUsahaCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jabatan / Posisi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={jabatanCustomer}
                          onChange={(e) => setJabatanCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Perusahaan / Usaha <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={alamatPerusahaanCustomer}
                          onChange={(e) =>
                            setAlamatPerusahaanCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No .Telp Perusahaan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={noTeleponPerusahaanCustomer}
                          onChange={(e) =>
                            setNoTeleponPerusahaanCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Lama Kerja / Status <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={lamaKerjaCustomer}
                          onChange={(e) => setLamaKerjaCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Besaran Gaji / Bulan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={gajiPekerjaanCustomer}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setGajiPekerjaanCustomer(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pendapatan Lain :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          value={pendapatanLainCustomer}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setPendapatanLainCustomer(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Penjamin */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Penjamin</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        NIK :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={nikPenjamin}
                          onChange={(e) => setNikPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. KK :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={noKkPenjamin}
                          onChange={(e) => setNoKkPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={namaPenjamin}
                          onChange={(e) => setNamaPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tempat Lahir :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={tempatLahirPenjamin}
                          onChange={(e) =>
                            setTempatLahirPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Lahir :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control />}
                          selected={tanggalLahirPenjamin}
                          onChange={(date) => setTanggalLahirPenjamin(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jenis Kelamin :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={jenisKelaminPenjamin}
                          onChange={(e) => {
                            setJenisKelaminPenjamin(e.target.value);
                          }}
                        >
                          {jenisKelaminOption.map((jenisKelamin) => (
                            <option value={jenisKelamin}>{jenisKelamin}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Agama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={agamaPenjamin}
                          onChange={(e) => {
                            setAgamaPenjamin(e.target.value);
                          }}
                        >
                          {agamaOption.map((agama) => (
                            <option value={agama}>{agama}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Telp / HP :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          type="number"
                          value={noTeleponPenjamin}
                          onChange={(e) => setNoTeleponPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={statusPerkawinanPenjamin}
                          onChange={(e) => {
                            setStatusPerkawinanPenjamin(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Perusahaan / Usaha :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={namaPerusahaanPenjamin}
                          onChange={(e) =>
                            setNamaPerusahaanPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Perusahaan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={alamatPerusahaanPenjamin}
                          onChange={(e) =>
                            setAlamatPerusahaanPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pekerjaan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={pekerjaanPenjamin}
                          onChange={(e) => setPekerjaanPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Lama Kerja / Status :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={lamaKerjaPenjamin}
                          onChange={(e) => setLamaKerjaPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kewarganegaraan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={kewarganegaraanPenjamin}
                          onChange={(e) => {
                            setKewarganegaraanPenjamin(e.target.value);
                          }}
                        >
                          {kewarganegaraanOption.map((kewarganegaraan) => (
                            <option value={kewarganegaraan}>
                              {kewarganegaraan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan nasabah :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={hubunganPenjamin}
                          onChange={(e) => setHubunganPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Alamat (Identitas) Penjamin */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Alamat (Identitas) Penjamin</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={alamatPenjamin}
                          onChange={(e) => setAlamatPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kel. / Desa :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kelurahanOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKelurahanPenjamin(
                                value.label.split(" ", 1)[0]
                              );
                            } else {
                              findKelurahanPenjamin("");
                            }
                          }}
                          value={kodeKelurahanPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={kodeKelurahanPenjamin !== "99999999"}
                          value={ketKelurahanPenjamin}
                          onChange={(e) =>
                            setKetKelurahanPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kecamatan :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kecamatanOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKecamatanPenjamin(value.label);
                            } else {
                              findKecamatanPenjamin("");
                            }
                          }}
                          value={kodeKecamatanPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={
                            kodeKecamatanPenjamin.split(" ", 1)[0] !== "999999"
                          }
                          value={ketKecamatanPenjamin}
                          onChange={(e) =>
                            setKetKecamatanPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kabupaten / Kota :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kabupatenOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKabupatenPenjamin(value.label);
                            } else {
                              findKabupatenPenjamin("");
                            }
                          }}
                          value={kodeKabupatenPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={
                            kodeKabupatenPenjamin.split(" ", 1)[0] !== "9999"
                          }
                          value={ketKabupatenPenjamin}
                          onChange={(e) =>
                            setKetKabupatenPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Provinsi :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={provinsiOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findProvinsiPenjamin(value.label);
                            } else {
                              findProvinsiPenjamin("");
                            }
                          }}
                          value={kodeProvinsiPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={
                            kodeProvinsiPenjamin.split(" ", 1)[0] !== "99"
                          }
                          value={ketProvinsiPenjamin}
                          onChange={(e) =>
                            setKetProvinsiPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode POS :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          type="number"
                          value={kodePosPenjamin}
                          disabled={
                            kodeKelurahanPenjamin.split(" ", 1)[0] !==
                            "99999999"
                          }
                          onChange={(e) => setKodePosPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Tempat Tinggal */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Tempat Tinggal</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Card style={{ marginTop: "10px" }}>
                  <Card.Header>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box></Box>
                      <Box>
                        <Form.Check
                          type="checkbox"
                          label="Sama dengan alamat identitas"
                          checked={alamatSamaPenjamin}
                          onChange={() => {
                            setAlamatSamaPenjamin(!alamatSamaPenjamin);
                            if (!alamatSamaPenjamin === true) {
                              setAlamatTTPenjamin(alamatPenjamin);
                              setKodeKelurahanTTPenjamin(kodeKelurahanPenjamin);
                              setKetKelurahanTTPenjamin(ketKelurahanPenjamin);
                              setKodeKecamatanTTPenjamin(kodeKecamatanPenjamin);
                              setKetKecamatanTTPenjamin(ketKecamatanPenjamin);
                              setKodeKabupatenTTPenjamin(kodeKabupatenPenjamin);
                              setKetKabupatenTTPenjamin(ketKabupatenPenjamin);
                              setKodeProvinsiTTPenjamin(kodeProvinsiPenjamin);
                              setKetProvinsiTTPenjamin(ketProvinsiPenjamin);
                              setKodePosTTPenjamin(kodePosPenjamin);
                            }
                          }}
                        />
                      </Box>
                    </Box>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatTTPenjamin}
                              onChange={(e) =>
                                setAlamatTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kelurahanOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKelurahanTTPenjamin(
                                    value.label.split(" ", 1)[0]
                                  );
                                } else {
                                  findKelurahanTTPenjamin("");
                                }
                              }}
                              value={kodeKelurahanTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeKelurahanTTPenjamin.split(" ", 1)[0] !==
                                "99999999"
                              }
                              value={ketKelurahanTTPenjamin}
                              onChange={(e) =>
                                setKetKelurahanTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kecamatanOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKecamatanTTPenjamin(
                                    value.label.split(" ", 1)[0]
                                  );
                                } else {
                                  findKecamatanTTPenjamin("");
                                }
                              }}
                              value={kodeKecamatanTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeKecamatanTTPenjamin.split(" ", 1)[0] !==
                                "999999"
                              }
                              value={ketKecamatanTTPenjamin}
                              onChange={(e) =>
                                setKetKecamatanTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kabupatenOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKabupatenTTPenjamin(value.label);
                                } else {
                                  findKabupatenTTPenjamin("");
                                }
                              }}
                              value={kodeKabupatenTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeKabupatenTTPenjamin.split(" ", 1)[0] !==
                                "9999"
                              }
                              value={ketKabupatenTTPenjamin}
                              onChange={(e) =>
                                setKetKabupatenTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={provinsiOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findProvinsiTTPenjamin(value.label);
                                } else {
                                  findProvinsiTTPenjamin("");
                                }
                              }}
                              value={kodeProvinsiTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeProvinsiTTPenjamin.split(" ", 1)[0] !== "99"
                              }
                              value={ketProvinsiTTPenjamin}
                              onChange={(e) =>
                                setKetProvinsiTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              type="number"
                              value={kodePosTTPenjamin}
                              disabled={
                                kodeKelurahanTTPenjamin.split(" ", 1)[0] !==
                                "99999999"
                              }
                              onChange={(e) =>
                                setKodePosTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Referensi */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Referensi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Ref. Register <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={namaRefRegister}
                          onChange={(e) => setNamaRefRegister(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Telepon Ref. Register <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={teleponRefRegister}
                          onChange={(e) =>
                            setTeleponRefRegister(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Ref. Register <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={alamatRefRegister}
                          onChange={(e) => setAlamatRefRegister(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan Nasabah <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={hubunganRefRegister}
                          onChange={(e) =>
                            setHubunganRefRegister(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={statusPerkawinanRefRegister}
                          onChange={(e) => {
                            setStatusPerkawinanRefRegister(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Ref. Register 2 <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={namaRef2Register}
                          onChange={(e) => setNamaRef2Register(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Telepon Ref. Register 2 <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={teleponRef2Register}
                          onChange={(e) =>
                            setTeleponRef2Register(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Ref. Register 2 <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={alamatRef2Register}
                          onChange={(e) =>
                            setAlamatRef2Register(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan Nasabah 2 <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={hubunganRef2Register}
                          onChange={(e) =>
                            setHubunganRef2Register(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={statusPerkawinanRef2Register}
                          onChange={(e) => {
                            setStatusPerkawinanRef2Register(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Ref. Register 3 <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={namaRef3Register}
                          onChange={(e) => setNamaRef3Register(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Telepon Ref. Register 3 <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={teleponRef3Register}
                          onChange={(e) =>
                            setTeleponRef3Register(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Ref. Register 3 <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={alamatRef3Register}
                          onChange={(e) =>
                            setAlamatRef3Register(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan Nasabah 3 <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={hubunganRef3Register}
                          onChange={(e) =>
                            setHubunganRef3Register(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={statusPerkawinanRef3Register}
                          onChange={(e) => {
                            setStatusPerkawinanRef3Register(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Pembiayaan / Struktur Pinjaman */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Pembiayaan / Struktur Pinjaman</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga OTR <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={hargaOtr}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setHargaOtr(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Uang Muka <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={uangMuka}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setUangMuka(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pokok Hutang <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={pinjamanAju}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setPinjamanAju(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Angsuran / Bulan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={angPerBulan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setAngPerBulan(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tenor <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={tenor}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setTenor(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Jt Tempo :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control />}
                          selected={tglJtTempo}
                          onChange={(date) => setTglJtTempo(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tujuan Penggunaan Dana <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={tujuanPenggunaanDana}
                          onChange={(e) =>
                            setTujuanPenggunaanDana(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pendingan / Pengurusan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={pendinganPengurusan}
                          onChange={(e) =>
                            setPendinganPengurusan(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Sumber Order / Marketing <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={marketingOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeMarketing.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setKodeMarketing(value.label.split(" ", 1)[0]);
                            } else {
                              setKodeMarketing("");
                            }
                          }}
                          value={kodeMarketing}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Kendaraan */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Kendaraan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Merk <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={merk}
                          onChange={(e) => setMerk(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={tipeOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && tipe.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findTipe(value.label);
                            } else {
                              findTipe("");
                            }
                          }}
                          value={tipe}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tahun <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={tahun}
                          onChange={(e) => setTahun(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Warna <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={warna}
                          onChange={(e) => {
                            setWarna(e.target.value);
                          }}
                        >
                          {warnas.map((warna, index) => (
                            <option value={warna.namaWarna}>
                              {warna.namaWarna}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        CC :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={isi}
                          onChange={(e) => setIsi(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Polisi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={nopol}
                          onChange={(e) => setNopol(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Rangka :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={noRangka}
                          onChange={(e) => setNoRangka(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Mesin :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={noMesin}
                          onChange={(e) => setNoMesin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. STNK :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control />}
                          selected={tglStnk}
                          onChange={(date) => setTglStnk(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Bpkb :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={noBpkb}
                          onChange={(e) => setNoBpkb(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        BPKB A/N :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={bpkbAN}
                          onChange={(e) => setBpkbAN(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat BPKB :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={bpkbAlamat}
                          onChange={(e) => setBpkbAlamat(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Denah Lokasi */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Denah Lokasi</Card.Header>
          <Card.Body>
            <Box sx={keteranganContainer}>
              <div>
                <div className="d-flex flex-wrap gap-2 align-items-center">
                  <button
                    type="button"
                    className="btn btn-sm btn-danger"
                    onClick={() => {
                      setDenahLokasiSurvey("");
                    }}
                  >
                    <DeleteOutlineIcon />
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    disabled={!eraseModeDenahLokasiSurvey}
                    onClick={handlePenClickDenahLokasiSurvey}
                  >
                    Pen
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    disabled={eraseModeDenahLokasiSurvey}
                    onClick={handleEraserClickDenahLokasiSurvey}
                  >
                    Hapus
                  </button>
                  <div className="vr" />
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleUndoClickDenahLokasiSurvey}
                  >
                    Undo
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleRedoClickDenahLokasiSurvey}
                  >
                    Redo
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleClearClickDenahLokasiSurvey}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleResetClickDenahLokasiSurvey}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </Box>
            <Box style={{ marginTop: "20px", height: "300px" }}>
              {denahLokasiSurvey && (
                <img
                  src={denahLokasiSurvey}
                  alt="Base64 Image"
                  style={{ maxWidth: "100%" }}
                />
              )}
              {!denahLokasiSurvey && (
                <ReactSketchCanvas
                  ref={canvasRefDenahLokasiSurvey}
                  strokeWidth={5}
                  strokeColor="black"
                />
              )}
              {/* <button onClick={handleExportImage}>Get Image</button> */}
            </Box>
          </Card.Body>
        </Card>

        {/* Keterangan */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Keterangan</Card.Header>
          <Card.Body>
            <Box sx={keteranganContainer}>
              <Form.Control
                as="textarea"
                rows={3}
                value={keterangan}
                onChange={(e) => setKeterangan(e.target.value)}
                style={{ textTransform: "uppercase" }}
              />
            </Box>
            <Box sx={keteranganContainer}>
              <Form.Control
                as="textarea"
                rows={6}
                disabled
                value={keteranganSurvey}
              />
            </Box>
            <Box sx={keteranganContainer}>
              <Box sx={textFieldWrapper}></Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <div>
                  <div className="d-flex flex-wrap gap-2 align-items-center">
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={() => {
                        setTtdSurvey("");
                      }}
                    >
                      <DeleteOutlineIcon />
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      disabled={!eraseMode}
                      onClick={handlePenClick}
                    >
                      Pen
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      disabled={eraseMode}
                      onClick={handleEraserClick}
                    >
                      Hapus
                    </button>
                    <div className="vr" />
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleUndoClick}
                    >
                      Undo
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleRedoClick}
                    >
                      Redo
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleClearClick}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleResetClick}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </Box>
            </Box>
            <Box sx={keteranganContainer}>
              <Box sx={textFieldWrapper}></Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <div>
                  {ttdSurvey && (
                    <img
                      src={ttdSurvey}
                      alt="Base64 Image"
                      style={{ maxWidth: "100%" }}
                    />
                  )}
                  {!ttdSurvey && (
                    <ReactSketchCanvas
                      ref={canvasRef}
                      strokeWidth={5}
                      strokeColor="black"
                    />
                  )}
                  {/* <button onClick={handleExportImage}>Get Image</button> */}
                </div>
              </Box>
            </Box>
            <Box sx={keteranganContainer}>
              <Box sx={textFieldWrapper}></Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="basic-addon1">{"("}</InputGroup.Text>
                  <Form.Control
                    value={namaTtdSurvey}
                    onChange={(e) => setNamaTtdSurvey(e.target.value)}
                    style={{ textTransform: "uppercase" }}
                  />
                  <InputGroup.Text id="basic-addon1">{")"}</InputGroup.Text>
                </InputGroup>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: "20px" }}>
          <Card.Header>
            <Typography variant="h5" sx={titleStyle} color="primary">
              UPLOAD FOTO
            </Typography>
          </Card.Header>
          <Card.Body>
            <Box sx={showDataContainer}>
              <Box sx={showDataWrapper}>
                {invalidImage !== null ? (
                  <h4 className="error"> {invalidImage} </h4>
                ) : null}
                <label className="text-white">Pilih Gambar :</label>
                <input
                  accept="image/*"
                  type="file"
                  id="select-image"
                  style={{ display: "none" }}
                  onChange={(e) => setArrayImage(e.target.files)}
                  multiple
                />
                <label htmlFor="select-image">
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    endIcon={<FileUploadIcon />}
                  >
                    Unggah Gambar
                  </Button>
                </label>
              </Box>
            </Box>
            <Box sx={listImageContainer}>
              {arrayImageUrl &&
                arrayImage &&
                arrayImageUrl.map((key, i) => (
                  <Card sx={imageCard} elevation={10}>
                    <CardActionArea>
                      <CardHeader title={`Gambar`} subheader={`No. ${i + 1}`} />
                      <CardMedia
                        component="img"
                        height="200px"
                        src={key}
                        alt={KeyOffRounded.name}
                      />
                    </CardActionArea>
                  </Card>
                ))}
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: "20px" }}>
          <Card.Header>
            <Typography variant="h5" sx={titleStyle} color="primary">
              FOTO LAMA
            </Typography>
          </Card.Header>
          <Card.Body>
            <Box sx={showDataContainer}>
              {gambar && (
                <Carousel breakPoints={breakPoints} sx={carouselStyle}>
                  {gambar &&
                    gambar.map((img, i) => (
                      <Card sx={oldImageCard} elevation={10}>
                        <CardActionArea disableRipple>
                          <CardHeader
                            title={`Gambar`}
                            subheader={`No. ${i + 1}`}
                          />
                          <CardMedia
                            component="img"
                            height="100%"
                            src={img.linkGambar}
                            alt="gambar"
                            sx={oldImageCardMedia}
                            onClick={() => {
                              window.open(
                                img.linkGambar,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }}
                          />
                        </CardActionArea>
                        <CardActions sx={oldImageCardAction}>
                          <IconButton aria-label="delete">
                            <DeleteIcon
                              color="error"
                              onClick={() => hapusGambar(img, i)}
                            />
                          </IconButton>
                        </CardActions>
                      </Card>
                    ))}
                </Carousel>
              )}
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate(`/surveyFidusia`)}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button variant="contained" startIcon={<SaveIcon />} type="submit">
            Simpan
          </Button>
        </Box>
      </Form>
      <Dialog
        open={openRegister}
        onClose={handleCloseRegister}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Register`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchData}>
              <Box sx={searchBarContainer}>
                <SearchBar value={query} setSearchTerm={setQuery} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Alamat
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      No. Telp / HP
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {registers.map((register, index) => (
                    <TableRow
                      key={register._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setRegisterFidusiaId(register.id);
                        setCustomerId(register.customer.id);
                        setCif(register.customer.cifCustomer);
                        setNikCustomer(register.customer.nikCustomer);
                        setNoKkCustomer(register.customer.noKkCustomer);
                        setNamaCustomer(register.customer.namaCustomer);
                        setNamaPanggilanCustomer(
                          register.customer.namaPanggilanCustomer
                        );
                        setTempatLahirCustomer(
                          register.customer.tempatLahirCustomer
                        );
                        setTanggalLahirCustomer(
                          new Date(register.customer.tanggalLahirCustomer)
                        );
                        setJenisKelaminCustomer(
                          register.customer.jenisKelaminCustomer
                        );
                        setAgamaCustomer(register.customer.agamaCustomer);
                        setNoTeleponCustomer(
                          register.customer.noTeleponCustomer
                        );
                        setAlamatCustomer(register.customer.alamatCustomer);
                        setAlamatTTCustomer(register.customer.alamatTTCustomer);
                        setKodeProvinsi(
                          `${register.customer.provinsis.id} - ${register.customer.provinsis.namaProvinsi}`
                        );
                        setKodeProvinsiTT(
                          `${register.customer.provinsisTT.id} - ${register.customer.provinsisTT.namaProvinsi}`
                        );
                        setKodeKabupaten(
                          `${register.customer.kabupaten.id} - ${register.customer.kabupaten.namaKabupaten}`
                        );
                        setKodeKabupatenTT(
                          `${register.customer.kabupatenTT.id} - ${register.customer.kabupatenTT.namaKabupaten}`
                        );
                        setKodeKecamatan(
                          `${register.customer.kecamatan.id} - ${register.customer.kecamatan.namaKecamatan}`
                        );
                        setKodeKecamatanTT(
                          `${register.customer.kecamatanTT.id} - ${register.customer.kecamatanTT.namaKecamatan}`
                        );
                        setKodeKelurahan(
                          `${register.customer.kelurahan.id} - ${register.customer.kelurahan.namaKelurahan}`
                        );
                        setKodeKelurahanTT(
                          `${register.customer.kelurahanTT.id} - ${register.customer.kelurahanTT.namaKelurahan}`
                        );
                        setKodePos(register.customer.kelurahan.kodePos);
                        setKodePosTT(register.customer.kelurahanTT.kodePos);
                        setStatusPerkawinanCustomer(
                          register.customer.statusPerkawinanCustomer
                        );
                        setPekerjaanCustomer(
                          register.customer.pekerjaanCustomer
                        );
                        setKewarganegaraanCustomer(
                          register.customer.kewarganegaraanCustomer
                        );

                        setNamaPerusahaanCustomer(
                          register.customer.namaPerusahaanCustomer
                        );
                        setBidangUsahaCustomer(
                          register.customer.bidangUsahaCustomer
                        );
                        setJabatanCustomer(register.customer.jabatanCustomer);
                        setAlamatPerusahaanCustomer(
                          register.customer.alamatPerusahaanCustomer
                        );
                        setNoTeleponPerusahaanCustomer(
                          register.customer.noTeleponPerusahaanCustomer
                        );
                        setLamaKerjaCustomer(
                          register.customer.lamaKerjaCustomer
                        );
                        setGajiPekerjaanCustomer(
                          register.customer.gajiPekerjaanCustomer
                        );
                        setPendapatanLainCustomer(
                          register.customer.pendapatanLainCustomer
                        );

                        setNikPenjamin(register.nikPenjamin);
                        setNoKkPenjamin(register.noKkPenjamin);
                        setNamaPenjamin(register.namaPenjamin);
                        setTempatLahirPenjamin(register.tempatLahirPenjamin);
                        setTanggalLahirPenjamin(
                          register.tanggalLahirPenjamin &&
                            new Date(register.tanggalLahirPenjamin)
                        );
                        setJenisKelaminPenjamin(register.jenisKelaminPenjamin);
                        setAgamaPenjamin(register.agamaPenjamin);
                        setNoTeleponPenjamin(register.noTeleponPenjamin);
                        setAlamatPenjamin(register.alamatPenjamin);
                        if (register.provinsisPenjamin) {
                          setKodeProvinsiPenjamin(
                            `${register.provinsisPenjamin.id} - ${register.provinsisPenjamin.namaProvinsi}`
                          );
                        }
                        if (register.kabupatenPenjamin) {
                          setKodeKabupatenPenjamin(
                            `${register.kabupatenPenjamin.id} - ${register.kabupatenPenjamin.namaKabupaten}`
                          );
                        }
                        if (register.kecamatanPenjamin) {
                          setKodeKecamatanPenjamin(
                            `${register.kecamatanPenjamin.id} - ${register.kecamatanPenjamin.namaKecamatan}`
                          );
                        }
                        if (register.kelurahanPenjamin) {
                          setKodeKelurahanPenjamin(
                            `${register.kelurahanPenjamin.id} - ${register.kelurahanPenjamin.namaKelurahan}`
                          );
                        }
                        if (register.kelurahanPenjamin) {
                          setKodePosPenjamin(
                            register.kelurahanPenjamin.kodePos
                          );
                        }
                        setStatusPerkawinanPenjamin(
                          register.statusPerkawinanPenjamin
                        );
                        setPekerjaanPenjamin(register.pekerjaanPenjamin);
                        setKewarganegaraanPenjamin(
                          register.kewarganegaraanPenjamin
                        );
                        setHubunganPenjamin(register.hubunganPenjamin);

                        setAlamatSamaPenjamin(register.alamatSamaPenjamin);
                        setAlamatTTPenjamin(register.alamatTTPenjamin);
                        if (register.provinsisTTPenjamin) {
                          setKodeProvinsiTTPenjamin(
                            `${register.provinsisTTPenjamin.id} - ${register.provinsisTTPenjamin.namaProvinsi}`
                          );
                        }
                        if (register.kabupatenTTPenjamin) {
                          setKodeKabupatenTTPenjamin(
                            `${register.kabupatenTTPenjamin.id} - ${register.kabupatenTTPenjamin.namaKabupaten}`
                          );
                        }
                        if (register.kecamatanTTPenjamin) {
                          setKodeKecamatanTTPenjamin(
                            `${register.kecamatanTTPenjamin.id} - ${register.kecamatanTTPenjamin.namaKecamatan}`
                          );
                        }
                        if (register.kelurahanTTPenjamin) {
                          setKodeKelurahanTTPenjamin(
                            `${register.kelurahanTTPenjamin.id} - ${register.kelurahanTTPenjamin.namaKelurahan}`
                          );
                        }
                        if (register.kelurahanTTPenjamin) {
                          setKodePosTTPenjamin(
                            register.kelurahanTTPenjamin.kodePos
                          );
                        }

                        setUangMuka(register.uangMuka);
                        setPinjamanAju(register.pinjamanAju);
                        setAngPerBulan(register.angPerBulan);
                        setTenor(register.tenor);

                        setMerk(register.merk);
                        setTipe(register.tipe);
                        setTahun(register.tahun);
                        setWarna(register.warna);
                        setNopol(register.nopol);

                        handleCloseRegister();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {register.customer.namaCustomer}
                      </TableCell>
                      <TableCell>{register.customer.alamatCustomer}</TableCell>
                      <TableCell>
                        {register.customer.noTeleponCustomer}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pages}
                page={page + 1}
                onChange={handleChange}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Hapus Data`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Yakin ingin menghapus data ${cif}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => hapusSurveyFidusia(id)}>Ok</Button>
          <Button onClick={handleCloseDelete}>Cancel</Button>
        </DialogActions>
      </Dialog>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahSurveyFidusiaLangsung;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const keteranganContainer = {
  marginTop: "20px",
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const mainContainer = {
  padding: 3,
  borderRadius: "20px",
  margin: {
    sm: 0,
    md: 4,
  },
  marginTop: {
    xs: 4,
    md: 0,
  },
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const titleStyle = {
  textAlign: "center",
  fontWeight: "600",
};

const listImageContainer = {
  display: "flex",
  flexWrap: "wrap",
};

const imageCard = {
  m: "auto",
  mt: 2,
};

const carouselStyle = {
  display: "flex",
  height: "400px",
};

const oldImageCard = {
  m: "auto",
  mt: 2,
  maxWidth: "500px",
  maxHeight: "500px",
  display: "flex",
  flexDirection: "column",
};

const oldImageCardMedia = {
  display: "flex",
  maxHeight: "150px",
};

const oldImageCardAction = {
  display: "flex",
  justifyContent: "center",
  mt: "auto",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const cetakContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const cetakCenter = {
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
  fontWeight: "bold",
  fontSize: "10px",
};

const cetakPage = {
  // border: "1px solid black",
  // height: "1600px",
  height: "1380px",
};

const cetakTitle = {
  padding: "5px",
  textAlign: "center",
  fontSize: "10px",
};

const formulirTextFieldContainer = {
  border: "1px solid black",
  padding: "2px",
};

const textStyle = {
  marginBottom: 2,
};

const formulirDataWrapper = {
  display: "flex",
  borderTop: "1px solid black",
  paddingBottom: "0px",
  fontSize: "10px",
};

const formulirTextValueContainer = {
  border: "1px solid black",
  padding: "2px",
  flex: 1,
};

const formulirDataAlamat = {
  display: "flex",
  paddingLeft: "10px",
  paddingRight: "10px",
  fontSize: "10px",
  height: "25px",
  border: "1px solid black",
};

const textStyleHidden = {
  marginBottom: 2,
  visibility: "hidden",
};

const boxStyle = {
  border: "1px solid black",
  marginRight: "10px",
  height: "20px",
  width: "20px",
};
